(ns teamoesterreich.user-mode.wana-help.nokat.panel-nokat
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.check :refer [check]]
    [reagent-material-ui.icons.close :refer [close]]
    [reagent-material-ui.icons.warning :refer [warning]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    ))

(defn activated-part [checked]
  (when checked
    [:div {:class "panel-check"}
     [check {:fontSize "large"}]
     [:span {:style {:display "inline-block" :vertical-align "top" :marginTop "7px"}}
      "Ich will mithelfen"]]

    ))

(defn check-part [checked]
  (if checked
    [:div {:class "panel-check"}
     [check {:fontSize "large"}]
     [:span {:style {:display "inline-block" :vertical-align "top" :marginTop "7px"}}
      "aktiv"]]

    [:div {:class "panel-check"}
     [close {:fontSize "large" :style {:color "#a66"}}]
     [:span {:style {:display "inline-block" :vertical-align "top" :marginTop "7px"}}
      "Nicht aktiv"]]
    ))

(defn warning-part [level text]
  (cond

    (= level 2)
    [:div {:class "panel-check"}
     [warning {:fontSize "large" :style {:color "red" :marginRight "30px"}}]
     [:span {:style {:display "inline-block" :vertical-align "top" :marginTop "7px"}}
      text]]

    (= level 1)
    [:div {:class "panel-check"}
     [warning {:fontSize "large" :style {:color "orange"}}]
     [:span {:style {:display "inline-block" :vertical-align "top" :marginTop "7px"}}
      text]]

    :else
    [:div {:style {:height "30px"}} ""]

    ))



(defn get-it []
  (let [!status (r/cursor store/app-state [:actual-user :status-nokat])
        !request (r/cursor store/app-state [:actual-user :request-nokat])
        !actual-user (r/cursor store/app-state [:actual-user])
        status @!status
        !warnings-text (r/cursor store/app-state [:actual-user :wanado-warnings :nokat-text])
        !warnings-level (r/cursor store/app-state [:actual-user :wanado-warnings :nokat-level])]
    [mui/grid
     {:container false
      :item      true
      :lg        5
      :xs        11

      }

     [mui/paper
      {
       :onClick #(a/set-page :wanaHelpNoKat)
       :class   "helping-panel"
       }

      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "flex-start"
        :spacing    3
        }
       [mui/grid
        {:container false
         :item      true
         :lg        3
         :xs        3
         :style     {:display "flex" :justify-content "center" :align-items "center"}
         }

        [:img {:src "/custom/img/kat_helfen_bunt.png" :alt "t-man" :class "helping-panel-icon"}]
        ]
       [mui/grid
        {:container false
         :item      true
         :lg        8
         :xs        8

         }

        [:h2 (if status
               (txt/txt :helping "Ohne-Katastrophe-Titel")
               (txt/txt :helping "Ohne-Katastrophe-Titel2"))]
        [:p (txt/txt :helping "Ohne-Katastrophe-Kachel")]

        ]
       [mui/grid
        {:container false
         :item      true
         :lg        8
         :xs        12
         }
        (activated-part @!request)
        (when @!request (check-part @!status))
        (when @!request (warning-part (or @!warnings-level 0) (or @!warnings-text "")))
        ]
       ]]
     ]
    ))